import Vue from 'vue'
import VueRouter from 'vue-router'
// import Home from '../views/Home.vue'
import Em from '../views/em.vue'
import AboutUs from '../views/aboutUs.vue'
import Integration from '../views/Integration.vue'
import Policy from '../views/policy.vue'
import Ins from '../views/index.vue'
import Protocol from '../views/protocol.vue'
import SdkList from '../views/sdkList'

Vue.use(VueRouter)

const routes = [
  // {
  //   path: '/',
  //   name: 'Protocol',
  //   component: Protocol
  // },
  // {
  //   path: '/',
  //   name: 'Em',
  //   component: Em
  // },
  {
    path: '/AboutUs',
    name: 'AboutUs',
    component: AboutUs
  },
  {
    path: '/Integration',
    name: 'Integration',
    component: Integration
  },
  {
    path: '/',
    name: 'Policy',
    component: Policy
  },
  {
    path: '/sdkList',
    name: 'SdkList',
    component: SdkList,
    meta: {
      title: '接入第三方SDK类信息列表'
    }
  },
  {
    path: '/Ins',
    name: 'Ins',
    component: Ins
  },
  {
    path: '/AboutUs',
    name: 'aboutUs',
    component: () => import(/* webpackChunkName: "about" */ '../views/aboutUs.vue')
  }
]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
